import { useContext } from "react"
import { ResumoFornecedorContext } from "./ResumoFornecedorContext"

export function useResumoFornecedorContext() {
    return useContext(ResumoFornecedorContext)
}
